import { ChangeDetectorRef, Injectable, Pipe, PipeTransform } from '@angular/core';
import { UiSafeStaff } from 'src/app/api/commonInterfaces';
import { StaffDisplayType, StaffService } from 'src/app/api/staff.service';
import { PreferencesService } from 'src/app/preferences.service';


export type EmptyDisplayOptions = "unknown" | "system"
@Pipe({
    name: 'staffDisplay',
    pure: false,
})
@Injectable({
  providedIn: 'root'
})
export class StaffDisplayPipe implements PipeTransform {

  value: string = ""
  loading = false
  prevStaffId: number = -1
  unknownValue = "Unknown Pelican"

  constructor(
    private staffService: StaffService,
    private ref: ChangeDetectorRef,
    private preferences: PreferencesService
  ) { }

  transform(value: number | string | UiSafeStaff | undefined | null, displayType: StaffDisplayType | undefined = undefined, emptyDisplay: EmptyDisplayOptions = "unknown"): string {


    if (value === undefined || value === null) {
      return ""
    }

    let staffId: number = 0;
    if (typeof value === "string") {
      staffId = parseInt(value, 10)
    }
    else if (typeof value === "number") {
      staffId = value
    }
    else {
      this.value = this.renderUser(value, displayType ?? this.preferences.staffDisplay)
      staffId = NaN
    }

    if ((staffId === 0 || staffId === 149)) {
      if (emptyDisplay === "system") {
        this.value = "System"
      }
      else {
        this.value = ""
      }
    }
    else {
      if (!Number.isNaN(staffId)) {
        if (this.loading === false && staffId !== this.prevStaffId) {
          this.loading = true
          this.prevStaffId = staffId
          this.staffService.getUserById(staffId).subscribe(
            user => {
              this.value = this.renderUser(user, displayType ?? this.preferences.staffDisplay)
              this.ref.markForCheck()
              this.loading = false
            }
          )
        }
      }
    }

    return this.value
  }


  private renderUser(user: UiSafeStaff | undefined, type: StaffDisplayType) {

    return this.staffService.displayName(user, {unknownValue: this.unknownValue})

  }

}
